import React from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Button, Icon, Menu } from 'semantic-ui-react'
import { Card } from 'semantic-ui-react'

import BillingSubscriptionsListItem from 'components/superuser/billing/BillingSubscriptionsListItem'
import EntitiesList from 'components/entities/EntitiesList'

import { getBillingSubscriptions } from 'selectors/billing'

const NewSubscriptionAction = () => (
  <Menu.Item>
    <Button as={NavLink} primary to={Routes.new_superuser_billing_subscription_path()}>
      <Icon name="plus"/> New subscription
    </Button>
  </Menu.Item>
)

const mapStateToProps = (state, ownProps) => ({
  entities: getBillingSubscriptions(state, ownProps),
  entityName: 'billingSubscription',
  item: BillingSubscriptionsListItem,
  listComponent: Card.Group,
  loading: state.meta?.billingSubscription?.loading,
  error: state.meta?.billingSubscription?.error,
  title: 'Subscriptions',
  extraActions: NewSubscriptionAction
})

export default connect(mapStateToProps)(EntitiesList)
